import React, { createContext, useContext, useReducer } from 'react';

import { ApplicationActionType } from './application.actions.types';
import { applicationReducer } from './application.reducer';
import { ApplicationContext } from './application.types';

export const initialState: ApplicationContext = {
  auth: {
    isFetching: false,
    isLogged: false,
    token: '',
  },
  providerInfo: {
    fantasyName: null,
    hasAdminContact: false,
    id: null,
    name: null,
    rut: null,
  },
  providers: [],
  recoverAccount: {
    email: null,
    isAuthorized: false,
    rut: null,
    userId: null,
  },
  userInfo: {
    email: null,
    id: null,
    name: null,
    phone: null,
    rut: null,
  },
};

const ContextApplication = createContext<{
  applicationDispatch: React.Dispatch<ApplicationActionType>;
  applicationState: ApplicationContext;
}>({
  applicationDispatch: () => null,
  applicationState: initialState,
});

const ApplicationProvider = ({ children }: { children: React.ReactNode | undefined }) => {
  const [applicationState, applicationDispatch] = useReducer(applicationReducer, initialState);

  return (
    <ContextApplication.Provider value={{ applicationDispatch, applicationState }}>
      {children}
    </ContextApplication.Provider>
  );
};

const useApplication = () => {
  const { applicationDispatch, applicationState } = useContext(ContextApplication);

  if (applicationState === undefined) {
    throw new Error('applicationState error');
  }
  if (applicationDispatch === undefined) {
    throw new Error('applicationDispatch error');
  }
  return { ...applicationState, applicationDispatch };
};

export { ApplicationProvider, useApplication };
